// ============================================
// ForgotPassword — Página /forgot-password
// Llama a POST /auth/customer/emailpass/reset-password de Medusa v2.
// Por seguridad, la respuesta es la misma exista o no la cuenta.
// ============================================

import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { MEDUSA_API_URL, MEDUSA_API_KEY } from '../services/medusa/config';
import SEO from '../components/SEO';
import './ForgotPassword.css';

export default function ForgotPassword() {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [submitted, setSubmitted] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!email.trim()) return;
    setLoading(true);
    setError('');

    try {
      // Medusa v2 emite el evento auth.password_reset con el token.
      // Devuelve 201 sin payload, mantenga o no exista la cuenta.
      await fetch(`${MEDUSA_API_URL}/auth/customer/emailpass/reset-password`, {
        method: 'POST',
        credentials: 'include',
        headers: {
          'Content-Type': 'application/json',
          'x-publishable-api-key': MEDUSA_API_KEY,
        },
        body: JSON.stringify({ identifier: email.trim() }),
      });
      setSubmitted(true);
    } catch (err) {
      setError(
        'No pudimos procesar la solicitud. Intenta de nuevo o escríbenos a hola@physiology.mx.'
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="forgot-page">
      <SEO
        title="Recuperar contraseña"
        description="Restablece tu contraseña de Physiology"
        path="/forgot-password"
        noindex
      />
      <div className="forgot-card">
        <header className="forgot-header">
          <span className="forgot-eyebrow">Cuenta Physiology</span>
          <h1 className="forgot-title">Recuperar contraseña</h1>
        </header>

        {!submitted ? (
          <>
            <p className="forgot-lead">
              Ingresa el correo de tu cuenta. Si existe, te enviaremos un enlace
              para restablecer la contraseña.
            </p>

            <form className="forgot-form" onSubmit={handleSubmit}>
              <label htmlFor="forgot-email" className="forgot-label">
                Correo electrónico
              </label>
              <input
                id="forgot-email"
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
                disabled={loading}
                placeholder="tucorreo@ejemplo.com"
                className="forgot-input"
                autoComplete="email"
              />

              {error && <p className="forgot-error">{error}</p>}

              <button
                type="submit"
                className="forgot-submit"
                disabled={loading || !email.trim()}
              >
                {loading ? 'Enviando…' : 'Enviar enlace de recuperación'}
              </button>
            </form>
          </>
        ) : (
          <div className="forgot-success">
            <p className="forgot-success-headline">
              Revisa tu bandeja de entrada.
            </p>
            <p className="forgot-success-body">
              Si <strong>{email}</strong> tiene una cuenta con nosotros, en breve
              recibirás un correo con instrucciones para restablecer tu
              contraseña.
            </p>
            <p className="forgot-success-help">
              ¿No te llega? Revisa la carpeta de correo no deseado o escríbenos a{' '}
              <a href="mailto:hola@physiology.mx">hola@physiology.mx</a>.
            </p>
          </div>
        )}

        <div className="forgot-footer">
          <Link to="/" className="forgot-back">
            ← Volver a la tienda
          </Link>
        </div>
      </div>
    </div>
  );
}
